<template>
    <layout>
        <div class="is-user-dashboard" v-if="!isGrantedBookKeeper">
            <div>
                <orders
                    ref="ordersComponent"
                    v-on:refreshTodos="refreshTodos"
                    v-on:openTagsForm="$refs.tagsForm.openWithRow($event)"
                />
                <todos
                    class="is-hidden-mobile is-hidden-tablet-only"
                    ref="todosComponent"
                />
            </div>
            <tour />
            <tags-form ref="tagsForm" @saved="$refs.ordersComponent.refreshTable()" />
        </div>
    </layout>
</template>

<script>
import Todos from './Todos';
import Orders from './Orders';
import Tour from './Tour'
import Modal from '@components/Modal';
import TagsForm from '@orders/dashboard/TagsForm';
import {currentUser} from "@utilities/functions";

export default {
    components: {
        Modal,
        Todos,
        Orders,
        Tour,
        TagsForm
    },

    computed: {
        isGrantedBookKeeper: function() {
            let loggedInUser = currentUser();
            return loggedInUser && loggedInUser.roles && loggedInUser.roles.includes('ROLE_BOOK_KEEPER');
        },
    },

    methods: {
        refreshTodos: function(){
            this.$refs.todosComponent.fetchTodos();
        }
    },

    created () {
        if(this.isGrantedBookKeeper) {
            window.location.replace(`/invoices`);
        }
    }
}
</script>
